<template>
  <div
    id="carSearch"
    :class="mode === 'rental' ? 'tab-pane in active' : 'tab-pane'"
  >
    <div class="search__box">
      <button
        class="close-btn"
        @click="$emit('closeModal')"
        v-if="modifySearch"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 512 512"
        >
          <path
            d="M289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34z"
            fill="currentColor"
          ></path>
        </svg>
      </button>
      <form @submit.prevent="search" id="searchRental">
        <template v-if="hasCompanySelector">
          <div class="rental-search-label-box">
            <div class="search-location-label">
              <label>Pickup Location</label>
            </div>
            <div class="rental-company-label">
              <label>Duration</label>
            </div>
          </div>

          <div class="search__box-inputBox">
            <div class="row">
              <div class="wrapping__search-row">
                <div class="col-sm-6 search--boxPhase-1">
                  <div class="wrap__input-box">
                    <div class="col-sm-12 pl-5">
                      <i class="ic-marker-maps"></i>
                      <input
                        class="searchBox__input searchBox__input-from"
                        :class="{
                          'field-error':
                            isSubmitted &&
                            $v.searchRequest.pickUpLocation.name.$error,
                        }"
                        type="text"
                        autocomplete="off"
                        tabindex="1"
                        v-model="searchRequest.pickUpLocation.name"
                        @keyup="onKeyupAutoComplete($event.target)"
                        @focus="onFocusAutoComplete($event.target)"
                        @blur="onBlurAutoComplete($event.target)"
                      />
                      <div class="list-autoComplete">
                        <ul
                          class="autoComplete-results"
                          id="autoComplete-rentalResults"
                        ></ul>
                      </div>
                    </div>
                    <div class="col-sm-6 differ-box hidden">
                      <i class="ic-marker-maps --grey50"></i>
                      <div
                        class="searchBox__input searchBox__input-to"
                        tabindex="2"
                      >
                        Surabaya
                      </div>
                      <input type="hidden" name="arrival" />
                    </div>
                  </div>
                </div>

                <div class="col-sm-6 search--boxPhase-3">
                  <div class="wrap__input-box" id="rentTime-wrapper">
                    <div class="col-sm-12">
                      <i class="ic-time plz"></i>
                      <span class="searchBox__input">
                        {{ searchRequest.durationInHour }}
                        {{
                          searchRequest.durationInHour === 1 ? "Hour" : "Hours"
                        }}
                      </span>
                      <div class="rentTime-box hidden">
                        <div>
                          <div class="col-sm-12">
                            <h5>
                              Duration
                              <span
                                >{{ searchRequest.durationInHour }}
                                {{
                                  searchRequest.durationInHour === 1
                                    ? "Hour"
                                    : "Hours"
                                }}</span
                              >
                            </h5>
                            <div class="text-center">
                              <div class="col-sm-12 plz list-time">
                                <ul class="picktime-hour">
                                  <li
                                    v-for="(item, index) in durationValue"
                                    :key="index"
                                  >
                                    <a
                                      href="javascript:void(0)"
                                      @click="onClickDurationPicker(item)"
                                      :class="{
                                        selected:
                                          item === searchRequest.durationInHour,
                                      }"
                                      >{{ item }}
                                      {{ item === 1 ? "Hour" : "Hours" }}</a
                                    >
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="crowen cBet">
                          <div class="list-time-footer cBet">
                            <a
                              href="javascript:void(0)"
                              class="--orange75 apply-renttime"
                              style="margin-left: auto"
                            >
                              <strong>Apply</strong>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="rental-search-label-box">
            <div class="rental-date-label">
              <label>Pickup Date & Time</label>
            </div>
            <div class="rental-time-label">
              <label>Company</label>
            </div>
          </div>

          <div class="search__box-inputBox">
            <div class="row">
              <div class="wrapping__search-row">
                <div class="col-sm-6 search--boxPhase-3">
                  <div class="wrap__input-box">
                    <div class="col-sm-6">
                      <i class="ic-date-checkin pl-5"></i>
                      <VueCtkDateTimePicker
                        id="rentalRentDate"
                        :min-date="minimumRentDate"
                        :max-date="maximumRentDate"
                        v-model="searchRequest.rentDate"
                        color="#025BC5"
                        format="YYYY-MM-DD"
                        formatted="MMM DD, YYYY"
                        auto-close
                        only-date
                        no-label
                        no-header
                        no-button
                        no-button-now
                      />
                    </div>
                    <div class="col-sm-6">
                      <i class="ic-time"></i>
                      <VueCtkDateTimePicker
                        id="airportPickUpTime"
                        v-model="searchRequest.rentTime"
                        color="#025BC5"
                        format="HH:mm"
                        formatted="HH:mm"
                        minute-interval="15"
                        overlay
                        only-time
                        no-label
                        no-header
                        no-button
                      />
                    </div>
                  </div>
                </div>

                <div class="col-sm-6 search--boxPhase-2">
                  <div class="col-sm-12" style="padding: 0">
                    <v-select
                      class="v-search-select airport-trr-select"
                      id="airport-trr-select"
                      placeholder="Select Company"
                      label="name"
                      :disabled="!hasCompanySelector"
                      v-model="searchRequest.company"
                      :options="companies || companyOption"
                      :clearable="true"
                      :searchable="true"
                      :filterable="true"
                      :reduce="(option) => option.id"
                    ></v-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="rental-search-label-box" id="search-rental-label-inline">
            <div class="search-location-label">
              <label>Pickup Location</label>
            </div>
            <div class="rental-date-label">
              <label>Pickup Date & Time</label>
            </div>
            <div class="rental-time-label">
              <label>Duration</label>
            </div>
          </div>

          <div class="search__box-inputBox">
            <div class="row">
              <div class="wrapping__search-row">
                <div class="col-sm-4 search--boxPhase-1">
                  <div class="wrap__input-box">
                    <div class="col-sm-12 pl-5">
                      <i class="ic-marker-maps"></i>
                      <input
                        class="searchBox__input searchBox__input-from"
                        :class="{
                          'field-error':
                            isSubmitted &&
                            $v.searchRequest.pickUpLocation.name.$error,
                        }"
                        type="text"
                        autocomplete="off"
                        tabindex="1"
                        v-model="searchRequest.pickUpLocation.name"
                        @keyup="onKeyupAutoComplete($event.target)"
                        @focus="onFocusAutoComplete($event.target)"
                        @blur="onBlurAutoComplete($event.target)"
                      />
                      <div class="list-autoComplete">
                        <ul
                          class="autoComplete-results"
                          id="autoComplete-rentalResults"
                        ></ul>
                      </div>
                    </div>
                    <div class="col-sm-6 differ-box hidden">
                      <i class="ic-marker-maps --grey50"></i>
                      <div
                        class="searchBox__input searchBox__input-to"
                        tabindex="2"
                      >
                        Surabaya
                      </div>
                      <input type="hidden" name="arrival" />
                    </div>
                  </div>
                </div>

                <div class="col-sm-3 search--boxPhase-2">
                  <div class="wrap__input-box">
                    <div class="col-sm-6">
                      <i class="ic-date-checkin pl-5"></i>
                      <VueCtkDateTimePicker
                        id="rentalRentDate"
                        :min-date="minimumRentDate"
                        :max-date="maximumRentDate"
                        v-model="searchRequest.rentDate"
                        color="#025BC5"
                        format="YYYY-MM-DD"
                        formatted="MMM DD"
                        auto-close
                        only-date
                        no-label
                        no-header
                        no-button
                        no-button-now
                      />
                    </div>
                    <div class="col-sm-6">
                      <i class="ic-time"></i>
                      <VueCtkDateTimePicker
                        id="airportPickUpTime"
                        v-model="searchRequest.rentTime"
                        color="#025BC5"
                        format="HH:mm"
                        formatted="HH:mm"
                        minute-interval="15"
                        overlay
                        only-time
                        no-label
                        no-header
                        no-button
                      />
                    </div>
                  </div>
                </div>

                <div class="col-sm-3 search--boxPhase-3">
                  <div class="wrap__input-box" id="rentTime-wrapper">
                    <div class="col-sm-12">
                      <i class="ic-time plz"></i>
                      <span class="searchBox__input">
                        {{ searchRequest.durationInHour }}
                        {{
                          searchRequest.durationInHour === 1 ? "Hour" : "Hours"
                        }}
                      </span>
                      <div class="rentTime-box hidden">
                        <div>
                          <div class="col-sm-12">
                            <h5>
                              Duration
                              <span
                                >{{ searchRequest.durationInHour }}
                                {{
                                  searchRequest.durationInHour === 1
                                    ? "Hour"
                                    : "Hours"
                                }}</span
                              >
                            </h5>
                            <div class="text-center">
                              <div class="col-sm-12 plz list-time">
                                <ul class="picktime-hour">
                                  <li
                                    v-for="(item, index) in durationValue"
                                    :key="index"
                                  >
                                    <a
                                      href="javascript:void(0)"
                                      @click="onClickDurationPicker(item)"
                                      :class="{
                                        selected:
                                          item === searchRequest.durationInHour,
                                      }"
                                      >{{ item }}
                                      {{ item === 1 ? "Hour" : "Hours" }}</a
                                    >
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="crowen cBet">
                          <div class="list-time-footer cBet">
                            <a
                              href="javascript:void(0)"
                              class="--orange75 apply-renttime"
                              style="margin-left: auto"
                            >
                              <strong>Apply</strong>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <button type="submit" class="btn btn-primary">
          FIND TRANSPORTATION
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { companySelectorHourly } from "@/helpers/userHelper.js";

export default {
  props: {
    mode: { type: String, required: true },
    companies: { type: Array },
    services: { type: Object },
  },
  data() {
    return {
      isSubmitted: false,
      isModifySearch: false,
      pickUpHours: [],
      pickUpMinutes: [],
      dropOffHours: [],
      dropOffMinutes: [],
      minimumRentDate: null,
      maximumRentDate: null,
      refreshSessionInterval: null,
      durationValue: [],
      searchRequest: {
        pickUpLocation: {
          name: null,
          address: null,
          country: null,
          latitude: 0,
          longitude: 0,
          isAirportZone: false,
        },
        rentDate: null,
        rentTime: null,
        durationInHour: null,
        isSelfDrive: false,
        mode: "",
        company: null,
      },
      permissions: null,
      companyOption: [],
      modifySearch: false,
    };
  },
  validations() {
    return {
      searchRequest: {
        pickUpLocation: { name: { required } },
        rentDate: { required },
        rentTime: { required },
        durationInHour: { required },
      },
    };
  },
  computed: {
    hasCompanySelector() {
      if (this.permissions) {
        return companySelectorHourly(this.permissions);
      }
      return companySelectorHourly(this.services);
    },
  },
  mounted() {
    const toggler = document.getElementsByClassName("toggle-box")[0];
    const self = this;
    if (toggler) {
      document
        .getElementsByClassName("toggle-wrapper")[0]
        .addEventListener("click", (event) => {
          self.searchRequest.isSelfDrive = !toggler.classList.toggle("active");
        });
    }
    document.addEventListener("click", (event) => {
      $.each(
        $("#carSearch .list-autoComplete, #carSearch .popularCity"),
        function (index, value) {
          value.classList.remove("isOpen");
        }
      );

      if ($("#carSearch .searchBox__input-from").is(event.target)) {
        const searchResult = $(event.target.parentElement).find(
          ".list-autoComplete"
        );
        const popularCity = $(event.target.parentElement).find(".popularCity");
        if (
          searchResult.length > 0 &&
          searchResult[0].getElementsByTagName("li").length > 0
        ) {
          searchResult[0].classList.add("isOpen");
        } else if (
          popularCity.length > 0 &&
          popularCity[0].getElementsByTagName("li").length > 0
        ) {
          popularCity[0].classList.add("isOpen");
        }
      }

      // toggle rentTime-box
      const rentTimeWrapper = document.querySelector("#rentTime-wrapper");
      if (rentTimeWrapper) {
        if (
          rentTimeWrapper.contains(event.target) &&
          !event.target.parentElement.classList.contains("apply-renttime")
        ) {
          document.querySelector(".rentTime-box").classList.remove("hidden");
        } else {
          document.querySelector(".rentTime-box").classList.add("hidden");
        }
      }
    });

    document.addEventListener("keydown", this.handleEnter);
  },
  async created() {
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    const profile = await this.$store.dispatch("user/getProfile");
    const userType = profile.userType;

    const minHourly = publicSettings.find(
      (val) => val.key === "MinimumHourlyHire"
    );
    let tempDurationList = [];
    for (let i = minHourly.value; i <= 24; i++) {
      tempDurationList.push(Number(i));
    }
    this.durationValue = tempDurationList;
    const minDays =
      userType === "TenantUser"
        ? 0
        : parseInt(
            this.$helper.extractSetting(publicSettings, "SearchMinDay", 0)
          );
    const maxMonths =
      userType === "TenantUser"
        ? 10000
        : parseInt(
            this.$helper.extractSetting(publicSettings, "BookingLimit", 0)
          );

    // const country = this.$helper.extractSetting(
    //   publicSettings,
    //   "CountryHours",
    //   0
    // );

    const self = this;
    // subscribe messages
    this.$eventBus.$on("navigateToVehicleRental", () => {
      self.$parent.autocomplete.refreshToken();
    });
    this.$eventBus.$on("bindVehicleRental", this.bindModelFromModifySearch);

    this.refreshSessionInterval = setInterval(() => {
      self.$parent.autocomplete.refreshToken();
    }, 60000);

    const defaultHour = 10;
    const defaultMinute = 0;

    this.minimumRentDate = this.$helper.toStringDate(
      this.$helper.addDays(minDays)
    );

    this.maximumRentDate = this.$helper.toStringDate(
      this.$helper.addMonths(maxMonths)
    );

    const pickUpLocations = this.$helper
      .extractSetting(
        publicSettings,
        "RentalPickup",
        "-6.2023616|106.8119382|National Monument|National Monument, Gambir, Central Jakarta City, Jakarta, Indonesia|ID"
      )
      .split("|");

    this.searchRequest = {
      pickUpLocation: {
        latitude: parseFloat(pickUpLocations[0]),
        longitude: parseFloat(pickUpLocations[1]),
        name: pickUpLocations[2],
        address: pickUpLocations[3],
        country: pickUpLocations[4],
        isAirportZone: false,
      },
      rentDate: this.$helper.toStringDate(this.$helper.addDays(minDays)),
      rentTime: `${defaultHour}:0${defaultMinute}`,
      durationInHour: Number(minHourly.value) || 1,
      isSelfDrive: false,
    };
  },
  beforeDestroy() {
    // unsubscribe message
    this.$eventBus.$off("navigateToVehicleRental");
    clearInterval(this.refreshSessionInterval);
    document.removeEventListener("keydown", this.handleEnter);
  },
  methods: {
    handleEnter(e) {
      if (this.mode !== "rental") return;
      if (e.key !== "Enter") return;

      if (e.target.classList.contains("vs__search")) {
        return;
      }

      e.preventDefault();
      this.search();
    },
    bindModelFromModifySearch(
      searchParameter,
      services,
      companies,
      modifySearch
    ) {
      this.permissions = services;
      this.companyOption = companies;
      this.modifySearch = modifySearch;
      this.searchRequest = {
        pickUpLocation: {
          latitude: searchParameter.location.latitude,
          longitude: searchParameter.location.longitude,
          name: searchParameter.location.name,
          address: searchParameter.location.address,
          country: searchParameter.location.country,
        },
        rentDate: this.$helper.toDateString(
          searchParameter.startRent,
          "YYYY-MM-DD"
        ),
        rentTime: `${searchParameter.startRent.hour}:${searchParameter.startRent.minute}`,
        durationInHour: Number(searchParameter.durationInHour),
        isSelfDrive: searchParameter.isSelfDrive,
        mode: searchParameter.mode,
        company: searchParameter.companyId || null,
      };

      this.isModifySearch = true;
    },
    onClickDurationPicker(hours) {
      this.searchRequest.durationInHour = hours;
    },
    onFocusAutoComplete(target) {
      target.value = "";
    },
    onBlurAutoComplete(target) {
      target.value = this.searchRequest.pickUpLocation.name;
    },
    onKeyupAutoComplete(target) {
      document
        .querySelectorAll(".popularCity")
        .forEach((element) => element.classList.remove("isOpen"));

      let self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout((_) => {
        const element = document.getElementById("autoComplete-rentalResults");

        // reset suggestion result
        element.innerHTML = "";

        // handle empty pick-up location keyword
        if (target.value === "") {
          element.parentElement.classList.remove("isOpen");
          return;
        }
        self.$parent.autocomplete.getPredictions(
          target.value,
          (predictions) => {
            // loop result
            predictions.forEach(function (prediction) {
              const item = document.createElement("li");
              item.innerHTML = `${self.$helper.getPlaceIcon(
                prediction.types,
                prediction.description
              )}<div class='point-of-view'>${
                prediction.structured_formatting.main_text
              }</div><span>${
                prediction.structured_formatting.secondary_text
              }</span>`;
              item.addEventListener("click", (_) => self.getPlace(prediction));
              element.appendChild(item);
            });
            // show the result
            element.parentElement.classList.add("isOpen");
          }
        );
      }, 200);
    },
    getPlace(prediction) {
      const self = this;
      self.$parent.autocomplete.getPlace(prediction, (place) => {
        const isAirportZone =
          prediction.types.includes("airport") ||
          prediction.description.toLowerCase().includes("airport")
            ? true
            : false;
        self.searchRequest.pickUpLocation = {
          latitude: place.latitude,
          longitude: place.longitude,
          name: place.name,
          address: place.address,
          country: place.country,
          isAirportZone,
        };
        // everytime user select the prediction, result list should be reset
        document.getElementById("autoComplete-rentalResults").innerHTML = "";
      });
    },
    buildQueryParam(request) {
      const queryParam = {};

      // pick-up location (coordinate & address)
      queryParam.plt = request.pickUpLocation.latitude;
      queryParam.plg = request.pickUpLocation.longitude;
      queryParam.pad = request.pickUpLocation.address;
      queryParam.pnm = request.pickUpLocation.name;
      queryParam.pcn = request.pickUpLocation.country;
      queryParam.pia = request.pickUpLocation.isAirportZone;

      // start rent
      queryParam.str = `${request.startRent.year}.${request.startRent.month}.${request.startRent.day}-${request.startRent.hour}.${request.startRent.minute}`;

      // end rent
      // queryParam.enr = `${request.endRent.year}.${request.endRent.month}.${request.endRent.day}-${request.endRent.hour}.${request.endRent.minute}`;

      // with driver / self drive
      queryParam.slf = request.isSelfDrive;

      // service type
      queryParam.duration = request.durationInHour;

      // service type
      queryParam.svc = "rental";

      // HACK: handle duplication routing
      queryParam.ver = Math.random().toString(36).substr(2, 9);

      // search mode
      queryParam.mode = request.mode;

      // companyId
      queryParam.company = request.company;

      return queryParam;
    },
    search() {
      this.isSubmitted = true;
      this.$v.searchRequest.$touch();
      if (this.$v.searchRequest.$error) {
        return;
      }
      // parse datetime
      if (
        this.searchRequest.rentDate &&
        this.searchRequest.rentTime &&
        this.searchRequest.durationInHour
      ) {
        const startRentDates = this.searchRequest.rentDate.split("-");
        const startRentTimes = this.searchRequest.rentTime.split(":");
        this.searchRequest.startRent = {
          year: parseInt(startRentDates[0]),
          month: parseInt(startRentDates[1]),
          day: parseInt(startRentDates[2]),
          hour: parseInt(startRentTimes[0]),
          minute: parseInt(startRentTimes[1]),
        };

        this.searchRequest.mode = "Inquiry";

        if (this.searchRequest.mode === "Inquiry") {
          if (this.isModifySearch) {
            this.$eventBus.$emit(
              "executeModifySearchRental",
              this.buildQueryParam(this.searchRequest)
            );
          } else {
            this.$router.push({
              path: "/availability/inquiry",
              query: this.buildQueryParam(this.searchRequest),
            });
          }
        } else {
          if (this.isModifySearch) {
            this.$eventBus.$emit(
              "executeModifySearchRental",
              this.buildQueryParam(this.searchRequest)
            );
          } else {
            this.$router.push({
              path: "/availability/instant",
              query: this.buildQueryParam(this.searchRequest),
            });
          }
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/availability/form/Rental.vue